import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Link,
  withRouter,
} from "react-router-dom";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import GeneralBloc from "../../../bloc/general_bloc";
import AppMainButton from "../../component/app_main_button/app_main_button";
import AppTransparentButton from "../../component/app_transparent_button/app_transparent_button";
import "./app_notice_dialog.css";
import AppTextField from "../../component/form/app_text_field/app_text_field";
import AppTextAreaField from "../../component/form/app_text_field/app_textarea_field";
import AppTextFieldConfig from "../../component/form/app_text_field/app_text_field_config";
import AppFieldContainer from "../../component/form/app_field_container/app_field_container";
import LanguageBloc from "../../../bloc/language_bloc";
import Labels from "../../constant/labels";
import { Input } from 'antd';
const { TextArea } = Input;

class AppNoticeDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state={
      additionalEmail:"",
      comment: "",
      refs: {
        additionalEmail: React.createRef(),           
        comment: React.createRef(),         
      }
    }
  }

  propTitle() {
    return this.props.title;
  }
  propSubTitle() {
    return this.props.subTitle;
  }
  propPositiveButton() {
    return this.props.positiveButton;
  }
  propNegativeButton() {
    return this.props.negativeButton;
  }

  propShowClose() {
    return this.props.showClose || false;
  }

  onValidateReject() {
    return this.state.comment.length > 0;
  }

  customerEmail() {
    let id = "customerEmail";    
    return (
       (
        <AppFieldContainer weight={1}>
          <TextArea            
            disabled={true}            
            rows={2}
            maxLength={100}
            style={{ marginBottom: "14px", borderRadius: 8, fontSize: "16px", resize: 'none',color:"rgb(29, 54, 94)"}}
            onChange={(e) => {                        
            }}
            value={"To: "+this.props.customerEmail}            
          />
          {/* <AppTextField
            id={id}            
            label={""}
            value={"To: "+this.props.customerEmail}
            type={AppTextFieldConfig.type.text}
            maxLength={100}
            disabled={AppTextFieldConfig.disabled.true}
            underline={AppTextFieldConfig.underline.normal}
            fontColor={AppTextFieldConfig.fontColor.black}
            compulsory={AppTextFieldConfig.compulsory.false}
            placeholder={""}
            textFormat={AppTextFieldConfig.textFormat.normal}
            onFormat={(value) => {
              
            }}
            onChange={(value) => {
              
            }}
            onValidate={(value, mode) => {
              return null;
            }}
            onBlur={(value) => {}}
            errorLabelGetter={(error) => {
              return null
            }}
          /> */}
        </AppFieldContainer>
      )
    );
  }

  agentEmail() {
    let id = "agentEmail";    
    return (
       (
        <AppFieldContainer weight={1}>
          <TextArea            
            disabled={true}                        
            rows={2}
            maxLength={100}
            style={{ marginBottom: "14px", borderRadius: 8, fontSize: "16px", resize: 'none',color:"rgb(29, 54, 94)"}}
            onChange={(e) => {          
              
            }}
            value={"CC: "+this.props.agentEmail}            
          />
          {/* <AppTextField
            id={id}            
            label={""}
            value={"CC: "+this.props.agentEmail}
            type={AppTextFieldConfig.type.text}
            maxLength={100}
            disabled={AppTextFieldConfig.disabled.true}
            underline={AppTextFieldConfig.underline.normal}
            fontColor={AppTextFieldConfig.fontColor.black}
            compulsory={AppTextFieldConfig.compulsory.false}
            placeholder={""}
            textFormat={AppTextFieldConfig.textFormat.normal}
            onFormat={(value) => {
              
            }}
            onChange={(value) => {
              
            }}
            onValidate={(value, mode) => {
              return null;
            }}
            onBlur={(value) => {}}
            errorLabelGetter={(error) => {
              return null
            }}
          /> */}
        </AppFieldContainer>
      )
    );
  }


  additionalEmail() {
    let id = "additionalEmail"
    return <AppFieldContainer>
        <AppTextAreaField
            id={id}
            ref={this.state.refs.additionalEmail}
            label={"Additional Email Address"}
            value={this.state.additionalEmail}
            type={AppTextFieldConfig.type.text}
            maxLength={500}
            disabled={AppTextFieldConfig.disabled.false}
            underline={AppTextFieldConfig.underline.normal}
            fontColor={AppTextFieldConfig.fontColor.black}
            compulsory={AppTextFieldConfig.compulsory.false}
            placeholder={""}
            textFormat={AppTextFieldConfig.textFormat.normal}
            onChange={(value) => {
                this.setState({
                  additionalEmail:value
                })
                if(this.props.getContent){
                  this.props.getContent(value);
                }                
            }}
            onValidate={(value, mode) => {                  
                return null
            }}
            onBlur={(value) => {
                return null;
            }}
            errorLabelGetter={(error) => {
              return LanguageBloc.getTextByCode(error);
            }}
        />
    </AppFieldContainer>
}

comment() {
  let id = "comment"
  return <AppFieldContainer>
      <AppTextAreaField
          id={id}
          ref={this.state.refs.comment}
          value={this.state.comment}
          type={AppTextFieldConfig.type.text}
          maxLength={200}
          disabled={AppTextFieldConfig.disabled.false}
          underline={AppTextFieldConfig.underline.normal}
          fontColor={AppTextFieldConfig.fontColor.black}
          compulsory={this.props.compulsory ? AppTextFieldConfig.compulsory.true :AppTextFieldConfig.compulsory.false  }
          placeholder={"Write down your comments here..."}
          textFormat={AppTextFieldConfig.textFormat.normal}
          onChange={(value) => {
              this.setState({
                comment:value
              })
              if(this.props.getContent){
                this.props.getContent(value);
              }                
          }}
          onValidate={(value, mode) => {                  
              return null
          }}
          onBlur={(value) => {
              return null;
          }}
          errorLabelGetter={(error) => {
            return LanguageBloc.getTextByCode(error);
          }}
      />
  </AppFieldContainer>
}

  render() {
    return (
      <Modal
        backdrop="static"
        centered
        style={{ maxWidth: "520px" }}
        isOpen={this.props.isOpen}
      >
        <ModalBody>
        {this.propShowClose() == true && (
          <div style={{ "text-align": "right", marginBottom: "-50px" }}>
            <div>
              <img
                src={
                  GeneralBloc.getAssetsContextPath() +
                  "/assets/images/Clear_Icon.svg"
                }
                className="terms_and_condition_close_button"
                onClick={() => this.props.onCloseDialog("no")}
              />
            </div>
          </div>
        )}
          <div className="row no-gutters notice_modal_content">
            <div className="col-md-12 text-left">
              <nobr><div className="notice_dialog_title"
              dangerouslySetInnerHTML={{
                __html: this.propTitle()
              }}
              ></div></nobr>
              <div className="notice_dialog_desc mt-2"
              dangerouslySetInnerHTML={{
                __html: this.propSubTitle()
              }}
              >               
              </div>
              
              <div className="button_container">
                <div style={{marginTop:"0px",width:"412px"}}>
                  {
                    this.props.showContent==true ? 
                    <div>
                      {
                        this.customerEmail()
                      }
                      {
                        this.agentEmail()
                      }
                      {
                        this.additionalEmail()
                      }
                    </div>
                    
                    :null
                  }
                   {
                    this.props.showComment==true ? 
                    <div>
                      {
                        this.comment()
                      }
                    </div>
                    
                    :null
                  }
                  {
                    this.props.showImageContent==true ? 
                    <div className="image_content_preview">
                      <img src={this.props.imageContent}  style={{height:"130px",objectFit:"contain" ,width:"98%"}}/>
                    </div> :null
                  }
                </div>
                {this.propPositiveButton() ? (
                  <>
                    <AppMainButton
                      //   label={this.props.lableNext}
                      label={this.propPositiveButton()}
                      enable={this.props.compulsory ? this.onValidateReject() : true}
                      //   enable={this.props.enable}
                      onClick={() => this.props.onCloseDialog("yes")}
                      icon={false}
                      buttonWidth={this.props.positiveButtonWidth || "385px"}
                    />
                  </>
                ) : null}
                {this.propNegativeButton() ? (
                  <>
                    <AppTransparentButton
                      //   label={this.props.lableSaveAndClose}
                      label={this.propNegativeButton()}
                      enable={this.props.enable}
                      onClick={() => this.props.onCloseDialog("no")}
                      buttonWidth={this.props.negativeButtonWidth || "385px"}
                    />
                  </>
                ) : null}
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
    );
  }
}
export default withRouter(AppNoticeDialog);
